import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeHigh } from '@fortawesome/free-solid-svg-icons';

import { Hero } from "../../components/header/header";
import Article from "./article";

import ImageBBC from "../../assets/images/articles/on-your-farm.webp";
import ImageMeetFarmers from "../../assets/images/articles/meet-the-farmers.webp";

function Articles() {
    const pageTitle = 'Publications';
    document.title = global.AppName + ' - ' + pageTitle;
    return (
        <>        
            <Hero title={"Cotmarsh Tannery CIC"} subtitle={"News and Magazine Articles"}></Hero>

            {/* start main */}
            <div className="main_bg">
                <div className="wrap">
                    <div className="main" id="home">
                        <h2>In the media</h2>
                        <p>Interviews and online articles about the tannery</p>
                        <section className='articles'>                          
                          <div className='article'>
                            <Link to='https://meet-the-farmers.simplecast.com/episodes/farming-fashion-and-a-254-000-grant-an-update-from-james-and-katie-allen' title='Meet the Farmers Podcast' target='_blank'>
                              <h3>Meet the Farmers<br></br>Podcast</h3>
                              <h4>Farming, Fashion and a £254,000 grant</h4>
                              <img src={ImageMeetFarmers} alt='Meet the Farmers - Podcast'></img>
                              <div>
                                <p>
                                  "In this episode, Ben Eagle catches up with James and Katie Allen, conservation graziers turned rural innovators, 
                                  now running a 170-acre farm near Swindon. They share how a £254,000 grant helped them build a sustainable on-farm 
                                  tannery and classroom, connecting farming with fashion and education."
                                </p>
                                <button className="listen-now">
                                  <FontAwesomeIcon icon={faVolumeHigh} /> Listen now
                                </button>
                              </div>
                            </Link>
                          </div>
                          <div className='article'>
                            <Link to='https://www.bbc.co.uk/sounds/play/m002bs08' title='BBC Radio 4 On Your Farm' target='_blank'>
                              <h3>BBC Radio 4<br></br>"On Your Farm"</h3>
                              <h4>Farming in Fashion</h4>
                              <img src={ImageBBC} alt='BBC Radio 4 On Your Farm'></img>
                              <div>
                                <p>
                                  "James and Katie Allen aren't from a farming background, but always dreamed of having their 
                                  own base to produce food, and fashion - both with nature in mind. In 2022, the dream was 
                                  realised when they bought an old dairy farm in Wiltshire.
                                  <br></br>
                                  <br></br>
                                  Katie uses the fleeces from her rare breed sheep to produce yarn, which she knits into jumpers 
                                  and hats, meanwhile James started researching how he could use the hides from his cattle to 
                                  produce leather. In this programme, Marie Lennon visits the farm in the final week of the 
                                  construction of the UK's first micro vegetable tannery, which James and Katie are hoping will not 
                                  only help them produce leather garments from the farm, but also boost a struggling leather industry."
                                </p>
                                <button className="listen-now">
                                  <FontAwesomeIcon icon={faVolumeHigh} /> Listen now
                                </button>
                              </div>
                            </Link>
                          </div>
                        </section>
                        <h2>Publications</h2>
                        <p>Some articles that have been published about the tannery.</p>
                        {/* <h3>some things you should know about us</h3> */}
                        <section className='articles'>
                          <Article stub='british-white-cattle-society-journal-2025' alt='British White Cattle Society Breed Journal 2025' /> 
                          <Article stub='world-leather-august-2024' alt='World Leather Magazine August 2024' /> 
                          <Article stub='cleft-stick-summer-2024' alt='Cleft Stick Magazine summer 2024' />                             
                        </section>
                        <div className="clear"></div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default Articles;